import React from 'react';
import { motion } from 'framer-motion';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 bg-[var(--color-sage)] relative overflow-hidden" data-id="element-28">
      <div className="absolute inset-0 bg-[var(--color-dark-sage)] opacity-10 mix-blend-multiply" data-id="element-29"></div>
      <div className="container mx-auto px-6 lg:px-12 relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-31">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-32">
            Estás a un paso de recuperar tu vitalidad natural
          </h2>

          <p className="text-xl text-white opacity-90 font-light mb-12 leading-relaxed" data-id="element-33">
            Únete a las mujeres que ya están viviendo su mejor versión con el
            Código Hormonal 40+.
          </p>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="block text-center w-full lg:w-auto lg:inline-block bg-white text-[var(--color-charcoal)] px-12 py-6 rounded-full text-xl font-medium hover:bg-[var(--color-cream)] transition-colors shadow-lg mb-6" data-id="element-34">
            Quiero empezar hoy — $8.49 →
          </a>

          <p className="text-white opacity-80 text-sm" data-id="element-35">
            Pago seguro via Shopify · PDF descargable · Disponible en cualquier
            dispositivo
          </p>
        </motion.div>
      </div>
    </section>;
}